import { render, staticRenderFns } from "./NotDefined.vue?vue&type=template&id=5b6bc34b&scoped=true"
import script from "./NotDefined.vue?vue&type=script&lang=js"
export * from "./NotDefined.vue?vue&type=script&lang=js"
import style0 from "./NotDefined.vue?vue&type=style&index=0&id=5b6bc34b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6bc34b",
  null
  
)

export default component.exports